import cn from "classnames"

import { Img } from "ui-kit/components-branded/index"
import { Price, Discount } from "components"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { usePrice } from "modules/Payment/FormPage/common/hooks"

interface Props {
    className?: string
    innerClassName?: string
}

export function PriceContainer({ className, innerClassName }: Props) {
    const [{ bookingDetails, currency }] = usePaymentContext()
    const { price, showDiscount, discount } = usePrice()

    return (
        <div className={cn(className)}>
            <div className={cn(innerClassName)}>
                <Img className="booking__small-emoji" src="credit-card-emoji.png" /> Стоимость&nbsp;
                <Price
                    psy={bookingDetails.psy}
                    singleServicePrice={price}
                    className="is-lowercase"
                    currency={currency}
                />
            </div>
            <Discount
                singleServicePrice={discount}
                psy={bookingDetails.psy}
                className="booking-cards__session-info-price-discount"
                showDiscountInBooking={showDiscount}
                currency={currency}
            />
        </div>
    )
}
